import CaptchaA from '@/components/CaptchaA.vue'
export default {
    data() {
        return {
            dialogVisible:false,
            form:{},
            info: {
            },
        };
    },
    components: {
        CaptchaA
    },
    methods: {
        // 关闭弹窗
        closeDialog() {
            this.dialogVisible = false;
        },
        // 校验确认密码与新密码是否一致
        checkPasswordMatch(rule, value, callback) {
            if (value !== this.form.newPassword) {
                callback(new Error('确认密码与新密码不一致'));
            } else {
                callback();
            }
        },

        // 提交表单
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    console.log("valid", valid);
                    this.form.phone = this.info.phone
                    console.log("valid,from", this.form);
                    let obj = {
                        ...this.form
                    }
                    this.$http.fixPassword(obj).then(res => {
                        if(res.code === 200){
                            this.$message.success('密码修改成功');
                            this.closeDialog();
                        }else {
                            this.$message.error(res.message);
                        }
                    })
                } else {
                    this.$message.error('请填写正确的表单信息');
                    return false;
                }
            });
        },
        // 弹窗关闭前的处理
        handleClose(done) {
            this.$confirm('确定关闭修改密码窗口吗？').then(() => {
                this.dialogVisible = false;
                done();
            }).catch(() => {});
        },

        fixPassword(){
            this.dialogVisible = true;
        },
        //
        logOut() {
            this.$store.commit("setToken", null);
            this.$store.commit("setCurrentUser", null);
            this.$cookie.delete('autoLoginCurrentUser');
            this.$cookie.delete('autoLoginToken');

            //清除账号密码登录cookie
            this.$cookie.delete('account');
            this.$cookie.delete('password');
            location.reload();
        },
        getUserInfo() {
            if (this.$store.state.currentUser !== null) {
                this.$http.getUserInfo().then(res => {
                    this.info = res.data;
                })
            }
        },
        routeToNeedLogin(path) {
            if (this.$store.state.currentUser === null) {
                this.$eventBus.$emit('doLogin');
                return;
            }
            if (this.info.status === '已禁用') {
                this.$hint.message.info(this.$t('账号已被禁用'));
                return;
            }

            if (path === '/Index/profile') {
                this.$router.push(path);
                return;
            }
            if (this.info.status === '待完善资料') {
                this.$hint.message.info(this.$t('请先完善个人资料'));
                return;
            }

            if (this.info.status === '待审核') {
                this.$hint.message.info(this.$t('请等待管理员审核通过'));
                return;
            }

            if (this.info.status === '审核未通过') {
                this.$hint.message.info(this.$t('审核未通过，请重新完善资料'));
                return;
            }
            this.$router.push(path);
        },
        doLogin() {
            this.$eventBus.$emit('doLogin');
        }
    },
    created() {
        // 验证码发送
        this.$eventBus.$on('sendPhoneVerificationCode',() => {
            this.sendPhoneVerificationCode();
        });
        this.getUserInfo();
    },
}
